import { Form, message, Button, Card, Input, DatePicker, Flex } from 'antd';
import React, { useEffect, useState } from 'react';

import certificationService from '../../services/certification.service';
import { useParams } from 'react-router-dom';
import { PageHeader } from '@ant-design/pro-components';
import { FilePdfOutlined, DownloadOutlined } from '@ant-design/icons';
import { downloadPDF } from '../../Helpers/Functions';
import modificationService from '../../services/modification.service';
import { useQuery } from 'react-query';

import { createDate, formatDate } from '../../Helpers/time-utils';

const DEFAULT_NOTE = '';

const ModificationGenerator = () => {
  const [loading, setLoading] = useState(false);
  const [required, setRequired] = useState(false);

  const [form] = Form.useForm();
  let { id } = useParams();

  const {
    data: { certification } = {},
    isFetching,
    refetch,
  } = useQuery(
    ['certifications', id],
    () => modificationService.getModification(id),
    {
      keepPreviousData: false,
      enabled: Number(id) > 0,
      refetchOnWindowFocus: false,
    },
  );

  const updateModification = async () => {
    const { observation, date, certificate_number } = form.getFieldsValue();

    const res = await certificationService.updateModifications(id, {
      observation,
      date,
      certificate_number,
    });
    return res;
  };

  const finish = async () => {
    try {
      const res = await updateModification();
      if (!res.success) {
        message.error(res.message);
        return;
      }

      message.success(res.message);
    } catch (error) {
      message.error(error.message);
    }
  };

  const certificateNow = async () => {
    setRequired(true);
    setTimeout(async () => {
      form
        .validateFields()
        .then(async (values) => {
          setLoading(true);
          await updateModification();
          const res = await certificationService.certificate(id);
          setLoading(false);
          if (!res.success) {
            message.error(res.message);
            return;
          }
          refetch();
          message.success(res.message);
        })
        .catch((err) => {
          setLoading(false);
          message.warning(err?.message || '¡Por favor completa los campos!');
        });
    }, 150);
  };

  const removeModel = () => {};

  useEffect(() => {
    if (certification) {
      form.setFieldsValue({
        certificate_number: certification.certificate_number ?? 'DG-26-0',
        date: createDate(certification.date) ?? createDate(),
        observation: certification.observation ?? DEFAULT_NOTE,
      });
    }
  }, [certification, form]);

  return (
    <React.Fragment>
      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title={`Modificaciones: ${certification?.plate} / ${
          certification?.inspection_number ?? ''
        }`}
        subTitle={formatDate(new Date(), 'LLL')}
        extra={[
          certification?.status === 'finished' && (
            <>
              <Button
                icon={<FilePdfOutlined />}
                key="show"
                onClick={() =>
                  downloadPDF(
                    true,
                    certification?.certificate_number,
                    certification?.pdf_url,
                  )
                }
                loading={loading || isFetching}
              >
                Ver
              </Button>

              <Button
                icon={<FilePdfOutlined />}
                key="show"
                onClick={() =>
                  downloadPDF(
                    true,
                    certification?.certificate_number,
                    `${certification?.pdf_url}?extra=true`,
                  )
                }
                loading={loading || isFetching}
              >
                Extra
              </Button>
            </>
          ),

          certification?.status === 'finished' && (
            <Button
              icon={<DownloadOutlined />}
              key="download"
              onClick={() =>
                downloadPDF(
                  false,
                  certification?.certificate_number,
                  certification?.pdf_url,
                )
              }
              loading={loading || isFetching}
            >
              Descargar
            </Button>
          ),
          <Button onClick={removeModel} danger key="cancel">
            Anular
          </Button>,
          <Button
            key="modifications"
            loading={loading}
            onClick={certificateNow}
          >
            Certificar
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Guardar
          </Button>,
        ]}
      />

      <Form
        layout="vertical"
        form={form}
        name="control-hooks"
        initialValues={{ chassis_status: 'NUEVO', type: 1, note_options: '' }}
        onFinish={finish}
      >
        <Flex gap={10} justify="space-between" style={{ width: '100%' }}>
          <div style={{ flex: 1 }}>
            <Card className="cardex" title="Datos del certificado">
              <Form.Item
                style={{ width: 200 }}
                name="certificate_number"
                label="Número de Certificado"
                rules={[
                  {
                    required: true,
                    message: 'Ingresa el numero de certificado',
                  },
                ]}
              >
                <Input
                  autoComplete="off"
                  aria-autocomplete="none"
                  size="middle"
                />
              </Form.Item>

              <Form.Item
                style={{ marginTop: 10 }}
                name="date"
                label="Fecha de certificación"
                rules={[{ required: true, message: 'Ingresa una fecha' }]}
              >
                <DatePicker style={{ width: 240 }} size="middle" />
              </Form.Item>

              <Form.Item
                name="observation"
                initialValue={DEFAULT_NOTE}
                label="Observaciones"
                rules={[{ required: false }]}
              >
                <Input.TextArea size="middle" />
              </Form.Item>
            </Card>
          </div>
        </Flex>
      </Form>
    </React.Fragment>
  );
};

const VerificationCharacteristicsBase = () => <ModificationGenerator />;

export default VerificationCharacteristicsBase;
